import { styled } from "@mui/material/styles";
import { Checkbox as MuiCheckbox, Typography } from "@mui/material";

export const CheckboxContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.space._300
}));

export const CustomCheckbox = styled(MuiCheckbox)(({ theme }) => ({
    backgroundColor: theme.colors["neutral.900"],
    borderRadius: "5px",
    color: theme.colors["neutral.700"],
    minWidth: "2rem",
    minHeight: "2rem",

    "&.MuiCheckbox-root:hover": {
        backgroundColor: theme.colors["neutral.900"],
        color: theme.colors["neutral.800"]
    },

    "&.MuiButtonBase-root.MuiCheckbox-root.isChecked": {
        backgroundColor: theme.colors["lime.500"],
        color: theme.colors["lime.800"],
        opacity: "1",

        "&:hover": {
            opacity: "0.8"
        }
    }
}));

export const CustomLabel = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.400"],
    fontFamily: theme.fonts.default,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
}));